import { HttpClient } from "@angular/common/http";
import { UrlService } from "./url.service";
import { catchError, EMPTY, Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { GroupAccount } from "../models/GroupAccount";

@Injectable({
  providedIn: 'root',
})
export class GroupAccountService {
  private readonly url: string;

  constructor(private readonly http: HttpClient, private readonly urlService: UrlService) {
    this.url = this.urlService.generateUrl('groupAccount');
  }

  getAllGroupAccounts(): Observable<GroupAccount[]> {
    return this.http.get<GroupAccount[]>(this.url + '/GetAllGroupAccounts').pipe(
      catchError((error: any) => this.handleError(error))
    );
  }

  private handleError(error: any): Observable<never> {
    return EMPTY;
  }
}
